import { connect } from 'react-redux';
import View from './EducationChartView';
import MobileView from './MobileEducationChartView';
import * as educationChartSelector from './EducationChartSelector';
import { getGoalsChartList } from './EducationChartActions';

const mapStateToProps = (state, props) => ({
    chartData: educationChartSelector.goalChartPopulated(state, props),
    chartTitle: educationChartSelector.chartTitle(state, props),
    dataIsOutdated: educationChartSelector.dataIsOutdated(state, props),
    fpId: educationChartSelector.fpId(state, props),
    goalId: educationChartSelector.goalId(state, props),
    hasChartData: educationChartSelector.hasChartData(state, props),
    hasLoaded: educationChartSelector.hasLoaded(state, props),
    isPdf: educationChartSelector.isPdf(state, props),
    isPrint: educationChartSelector.isPrint(state, props),
});

const mapDispatchToProps = dispatch => ({
    getChartData: (fpId, clientId, goalId, isPdf) => (
        dispatch(getGoalsChartList(fpId, clientId, goalId, isPdf))
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileEducationChart = connect(mapStateToProps, mapDispatchToProps)(MobileView);
